export default {
  FundList: {
    Title: 'Quỹ tiền',
    DictionaryFund: '/ Ngân hàng / Quỹ tiền',
    Dictionary: 'Danh mục',
  },
  FundDetail: {
    FundName: 'Tên quỹ tiền *',
    Description: 'Diễn giải',
    Follow: 'Theo dõi',
  },
};
